module.exports={render:function (){var _vm=this;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["电子保单"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_vm._h('div', {
    attrs: {
      "id": "myIframe"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-7713c005!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/insurance/InsurancePdf.vue
// module id = 216
// module chunks = 1